import React from 'react';
import {useTranslation} from 'react-i18next';

import {ChannelLogo} from '../../channels/ChannelLogo';
import {
    ANALYTICS_CHANNEL, SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, WOOCOMMERCE_CHANNEL,
} from '../../channels/channels';

/**
 * «Google Analytics y tu tienda se conectan después».
 *
 * Va DENTRO de la grilla de plataformas y no como una nota al pie, que es donde estaba y donde no la
 * leía nadie. La pregunta que responde —«¿y Shopify?»— se le ocurre al usuario mientras escanea las
 * cuatro tarjetas buscando la suya, así que la respuesta tiene que estar en ese mismo barrido: al
 * pie de la página llega tarde, cuando ya concluyó que Dashbo no conecta su tienda.
 *
 * Lleva los logos por la misma razón: quien busca Shopify busca el logo de Shopify, no la palabra
 * «ecommerce». Y no lleva ningún botón —no hay nada que hacer acá todavía—, así que se distingue de
 * las cuatro que sí son accionables con el borde punteado y el fondo apagado.
 */
const LATER_CHANNELS = [ANALYTICS_CHANNEL, SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, WOOCOMMERCE_CHANNEL];

export function LaterPlatformsCard() {
    const {t} = useTranslation();

    return (
        <article className="ob-platform -later">
            <div className="ob-platform__logos" aria-hidden="true">
                {LATER_CHANNELS.map(channel => (
                    <span className="ob-platform__logo -mini" key={channel}>
                        <ChannelLogo channel={channel} hspace={0} vspace={0} marginLeft={0} padding={0}/>
                    </span>
                ))}
            </div>
            <div>
                <p className="ob-platform__later-title">{t('onboarding.platforms.later_title')}</p>
                <p className="ob-platform__hint">{t('onboarding.platforms.later_body')}</p>
            </div>
        </article>
    );
}

export default LaterPlatformsCard;
